import {get, post, deleteData} from '@/utils/fetch'
import {sha256} from 'js-sha256'

// 角色管理
export function getRole(data) {
  return get({
    url: 'manage/sys/role/list',
    data
  })
}
// 新增角色
export function addRole(data) {
 return post({
    url: 'manage/sys/role/save',
    data
 })
}
// 删除角色
export function deleteRole(data) {
  return deleteData({
    url: 'manage/sys/role/delete',
    data
  })
}
// 验证角色唯一
export function checkRoleName(data) {
  return get({
    url: 'manage/sys/role/checkRoleName',
    data
  })
}
// 查询角色权限
export function getRoleTree(data) {
  return post({
    url: 'manage/sys/role/tree',
    data
  })
}
// 角色设置权限
export function addRoleMenu(data) {
  return post({
    url: 'manage/sys/role/addRoleMenu',
    data
  })
}

// 用户管理
export function getUser(data) {
  return get({
    url: 'manage/sys/user',
    data
  })
}
// 用户名唯一验证
export function checkLoginName(data) {
  return get({
    url: 'manage/sys/user/check/login/name',
    data
  })
}
// 新增用户
export function addUser(data) {
  return post({
    url: 'manage/sys/user/save',
    data
  })
}
//删除用户之前的判断 herong
export function preDelete(data) {
  return post({
    url: 'manage/sys/user/pre-delete',
    data
  })
}
// 删除用户
export function deleteUser(data) {
  return post({
    url: 'manage/sys/user/delete',
    data
  })
}
// 重置密码
export function resetPassword(data) {
  return post({
    url: 'manage/sys/user/resetPassword',
    data
  })
}
// 设置密码
export function updatePassword(data) {
  let psd = data.newPassword;
  return post({
    url: 'manage/sys/user/update/password',
    data: {
      thisId: data.thisId,
      newPassword: psd
    }
  })
}
// 锁定启动用户
export function setLockState(data) {
  return post({
    url: 'manage/sys/user/lockState',
    data
  })
}
// 模拟用户
export function analog(orgId, userId) {
  return get({
    url: 'manage/sys/user/analog/' +orgId + '/' + userId
  })
}
// 用户权限查询
export function getUserMenuList(data) {
  return get({
    url: 'manage/sys/role/getUserMenuList',
    data
  })
}
// 用户角色查询
export function queryRole(data) {
  return get({
    url: 'manage/sys/user/queryRole',
    data
  })
}
// 分配用户角色
export function addUserRoles(data) {
  return post({
    url: 'manage/sys/user/addUserRole',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/userManage.js